import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { style: {"width":"100%","display":"block"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "text-body-1 mb-6"
}
const _hoisted_7 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_8 = {
  key: 0,
  class: "text-body-1 mb-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_ctx.modalShow)
    ? (_openBlock(), _createBlock(_component_v_dialog, {
        key: 0,
        modelValue: _ctx.modalShow,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.modalShow) = $event)),
        width: "800",
        persistent: ""
      }, {
        default: _withCtx(() => [
          (_ctx.location)
            ? (_openBlock(), _createBlock(_component_v_form, {
                key: 0,
                ref: "form",
                onSubmit: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"])),
                modelValue: _ctx.valid,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.valid) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { "primary-title": "" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, [
                            (!_ctx.location.id)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t("message.new") + ' ' + _ctx.$tc("message.locationsType" + _ctx.model.locationsType + "Name",1).toLowerCase()), 1))
                              : _createCommentVNode("", true),
                            (_ctx.location.id)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t("message.edit") + ' ' + _ctx.$tc("message.locationsType" + _ctx.model.locationsType + "Name",1).toLowerCase()), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_spacer),
                          (_ctx.location.changeType == 1 || !_ctx.location.id)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(_component_v_text_field, {
                                  class: "mb-3",
                                  density: "compact",
                                  onChange: _ctx.changed,
                                  ref: "locationname",
                                  modelValue: _ctx.location.name,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.location.name) = $event)),
                                  variant: "outlined",
                                  label: _ctx.$t('message.name'),
                                  rules: _ctx.nameRules,
                                  required: ""
                                }, null, 8, ["onChange", "modelValue", "label", "rules"]),
                                (_ctx.location != null && _ctx.model.locationGroups != null && _ctx.model.locationGroups.length > 1)
                                  ? (_openBlock(), _createBlock(_component_v_select, {
                                      key: 0,
                                      class: "mb-3",
                                      density: "compact",
                                      onChange: _ctx.changed,
                                      clearable: _ctx.model.locationGroupMandatory == false,
                                      label: _ctx.$tc('message.locationGroupsType' + _ctx.model.locationGroupsType + 'Name'),
                                      variant: "outlined",
                                      items: _ctx.selectableLocationGroups,
                                      "item-value": "id",
                                      "item-title": "name",
                                      modelValue: _ctx.location.locationGroup,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.location.locationGroup) = $event))
                                    }, null, 8, ["onChange", "clearable", "label", "items", "modelValue"]))
                                  : _createCommentVNode("", true),
                                (_ctx.location != null && _ctx.location.locationClusters != null && _ctx.location.locationClusters.length > 0)
                                  ? (_openBlock(), _createBlock(_component_v_select, {
                                      key: 1,
                                      class: "mb-3",
                                      density: "compact",
                                      onChange: _ctx.changed,
                                      clearable: "",
                                      label: _ctx.$tc('message.locationClustersType' + _ctx.model.locationClustersType + 'Name'),
                                      variant: "outlined",
                                      items: _ctx.location.locationClusters,
                                      "item-value": "id",
                                      "item-title": "name",
                                      modelValue: _ctx.location.locationCluster,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.location.locationCluster) = $event))
                                    }, null, 8, ["onChange", "label", "items", "modelValue"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.location.changeType != 1 && _ctx.location.id)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(_component_v_text_field, {
                                  class: "mb-3",
                                  density: "compact",
                                  onChange: _ctx.changed,
                                  ref: "locationname",
                                  readonly: "",
                                  disabled: "",
                                  modelValue: _ctx.location.name,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.location.name) = $event)),
                                  variant: "outlined",
                                  label: _ctx.$t('message.name'),
                                  rules: _ctx.nameRules,
                                  required: ""
                                }, null, 8, ["onChange", "modelValue", "label", "rules"]),
                                (_ctx.location != null && _ctx.model.locationGroups != null && _ctx.model.locationGroups.length > 1)
                                  ? (_openBlock(), _createBlock(_component_v_select, {
                                      key: 0,
                                      class: "mb-3",
                                      density: "compact",
                                      onChange: _ctx.changed,
                                      readonly: "",
                                      disabled: "",
                                      label: _ctx.$tc('message.locationGroupsType' + _ctx.model.locationGroupsType + 'Name'),
                                      variant: "outlined",
                                      items: _ctx.model.locationGroups,
                                      "item-value": "id",
                                      "item-title": "name",
                                      modelValue: _ctx.location.locationGroup,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.location.locationGroup) = $event))
                                    }, null, 8, ["onChange", "label", "items", "modelValue"]))
                                  : _createCommentVNode("", true),
                                (_ctx.location != null && _ctx.location.locationClusters != null && _ctx.location.locationClusters.length > 0)
                                  ? (_openBlock(), _createBlock(_component_v_select, {
                                      key: 1,
                                      class: "mb-3",
                                      density: "compact",
                                      onChange: _ctx.changed,
                                      readonly: "",
                                      disabled: "",
                                      label: _ctx.$tc('message.locationClustersType' + _ctx.model.locationClustersType + 'Name'),
                                      variant: "outlined",
                                      items: _ctx.location.locationClusters,
                                      "item-value": "id",
                                      "item-title": "name",
                                      modelValue: _ctx.location.locationCluster,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.location.locationCluster) = $event))
                                    }, null, 8, ["onChange", "label", "items", "modelValue"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationPropertiesBySection, (section, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                              (section[1][0].sectionViewSize > 0 && section[1]?.some(p => p.title != null && p.visible))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 'section' + index
                                  }, [
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          class: "text-h6",
                                          onClick: ($event: any) => (section[1][0].sectionSecondary = !section[1][0].sectionSecondary),
                                          style: {"cursor":"pointer","color":"#009cbb"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(section[1][0].sectionTitle), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_col, { class: "text-right" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn, {
                                              icon: "",
                                              variant: "text",
                                              onClick: ($event: any) => (section[1][0].sectionSecondary = !section[1][0].sectionSecondary)
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_icon, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(section[1][0].sectionSecondary ? 'mdi-chevron-down' : 'mdi-chevron-up'), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    (section[1][0].sectionLabel)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(section[1][0].sectionLabel), 1))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_7))
                                  ]))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section[1].filter(p => p.title != null && p.visible), (locationProperty, indexProperty) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: 'section' + index + 'property' + indexProperty
                                }, [
                                  _createVNode(_component_v_expand_transition, null, {
                                    default: _withCtx(() => [
                                      _withDirectives((_openBlock(), _createElementBlock("div", {
                                        class: "mb-3",
                                        key: 'section' + index + 'property' + indexProperty
                                      }, [
                                        (locationProperty.label)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(locationProperty.label), 1))
                                          : _createCommentVNode("", true),
                                        (locationProperty.dataType == 0 && locationProperty.choices == null)
                                          ? (_openBlock(), _createBlock(_component_v_text_field, {
                                              key: 1,
                                              density: "compact",
                                              onChange: _ctx.changed,
                                              hint: locationProperty.description,
                                              modelValue: locationProperty.stringValue,
                                              "onUpdate:modelValue": ($event: any) => ((locationProperty.stringValue) = $event),
                                              variant: "outlined",
                                              label: _ctx.removeMdiBracketToIcon(locationProperty.title)
                                            }, null, 8, ["onChange", "hint", "modelValue", "onUpdate:modelValue", "label"]))
                                          : _createCommentVNode("", true),
                                        (locationProperty.minimumValue != null && locationProperty.maximumValue != null && locationProperty.dataType != 0 && locationProperty.choices ==null)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                              ((locationProperty.dataType == 1 || locationProperty.dataType == 3 || locationProperty.dataType == 4))
                                                ? (_openBlock(), _createBlock(_component_v_slider, {
                                                    key: 0,
                                                    density: "compact",
                                                    onChange: _ctx.changed,
                                                    hint: locationProperty.description,
                                                    label: _ctx.removeMdiBracketToIcon(locationProperty.title),
                                                    min: locationProperty.minimumValue,
                                                    max: locationProperty.maximumValue,
                                                    step: 1,
                                                    modelValue: locationProperty.numberValue,
                                                    "onUpdate:modelValue": ($event: any) => ((locationProperty.numberValue) = $event)
                                                  }, {
                                                    append: _withCtx(() => [
                                                      _createVNode(_component_v_text_field, {
                                                        density: "compact",
                                                        "hide-details": "",
                                                        "single-line": "",
                                                        type: "number",
                                                        style: {"width":"80px","margin-top":"-5px","padding-top":"0"},
                                                        min: locationProperty.minimumValue,
                                                        max: locationProperty.maximumValue,
                                                        "model-value": locationProperty.numberValue,
                                                        "onUpdate:modelValue": ($value) => (locationProperty.numberValue = parseFloat($value) || null),
                                                        onChange: _ctx.changed
                                                      }, null, 8, ["min", "max", "model-value", "onUpdate:modelValue", "onChange"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onChange", "hint", "label", "min", "max", "modelValue", "onUpdate:modelValue"]))
                                                : _createCommentVNode("", true),
                                              ((locationProperty.dataType == 2))
                                                ? (_openBlock(), _createBlock(_component_v_slider, {
                                                    key: 1,
                                                    density: "compact",
                                                    onChange: _ctx.changed,
                                                    hint: locationProperty.description,
                                                    label: _ctx.removeMdiBracketToIcon(locationProperty.title),
                                                    min: locationProperty.minimumValue,
                                                    max: locationProperty.maximumValue,
                                                    step: 1,
                                                    modelValue: locationProperty.percentageValue,
                                                    "onUpdate:modelValue": ($event: any) => ((locationProperty.percentageValue) = $event)
                                                  }, {
                                                    append: _withCtx(() => [
                                                      _createVNode(_component_v_text_field, {
                                                        density: "compact",
                                                        "hide-details": "",
                                                        "single-line": "",
                                                        type: "number",
                                                        style: {"width":"80px","margin-top":"-5px","padding-top":"0"},
                                                        min: locationProperty.minimumValue,
                                                        max: locationProperty.maximumValue,
                                                        "model-value": locationProperty.percentageValue,
                                                        "onUpdate:modelValue": ($value) => (locationProperty.percentageValue = parseFloat($value) || null),
                                                        onChange: _ctx.changed
                                                      }, null, 8, ["min", "max", "model-value", "onUpdate:modelValue", "onChange"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onChange", "hint", "label", "min", "max", "modelValue", "onUpdate:modelValue"]))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                          : _createCommentVNode("", true),
                                        ((locationProperty.minimumValue == null || locationProperty.maximumValue == null) && locationProperty.dataType != 0  && locationProperty.choices ==null)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                              ((locationProperty.dataType == 1 || locationProperty.dataType == 3 || locationProperty.dataType == 4) && locationProperty.choices == null)
                                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                                    key: 0,
                                                    density: "compact",
                                                    onChange: _ctx.changed,
                                                    hint: locationProperty.description,
                                                    "model-value": locationProperty.numberValue,
                                                    "onUpdate:modelValue":  ($value) => (locationProperty.numberValue = parseFloat($value) || null) ,
                                                    variant: "outlined",
                                                    label: _ctx.removeMdiBracketToIcon(locationProperty.title),
                                                    type: "number"
                                                  }, null, 8, ["onChange", "hint", "model-value", "onUpdate:modelValue", "label"]))
                                                : _createCommentVNode("", true),
                                              ((locationProperty.dataType == 2) && locationProperty.choices == null)
                                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                                    key: 1,
                                                    density: "compact",
                                                    onChange: _ctx.changed,
                                                    hint: locationProperty.description,
                                                    "model-value": locationProperty.percentageValue,
                                                    "onUpdate:modelValue":  ($value) => (locationProperty.percentageValue = parseFloat($value) || null) ,
                                                    variant: "outlined",
                                                    label: _ctx.removeMdiBracketToIcon(locationProperty.title),
                                                    type: "number"
                                                  }, null, 8, ["onChange", "hint", "model-value", "onUpdate:modelValue", "label"]))
                                                : _createCommentVNode("", true),
                                              (locationProperty.dataType == 5)
                                                ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                                    key: 2,
                                                    density: "compact",
                                                    onChange: _ctx.changed,
                                                    hint: locationProperty.description,
                                                    modelValue: locationProperty.numberValue,
                                                    "onUpdate:modelValue": ($event: any) => ((locationProperty.numberValue) = $event),
                                                    label: _ctx.removeMdiBracketToIcon(locationProperty.title),
                                                    "true-value": 1,
                                                    "false-value": 0
                                                  }, null, 8, ["onChange", "hint", "modelValue", "onUpdate:modelValue", "label"]))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                          : _createCommentVNode("", true),
                                        (locationProperty.dataType == 0 && locationProperty.choices !=null)
                                          ? (_openBlock(), _createBlock(_component_v_select, {
                                              key: 4,
                                              density: "compact",
                                              onChange: _ctx.changed,
                                              hint: locationProperty.description,
                                              modelValue: locationProperty.stringValue,
                                              "onUpdate:modelValue": ($event: any) => ((locationProperty.stringValue) = $event),
                                              variant: "outlined",
                                              items: locationProperty.choices,
                                              label: _ctx.removeMdiBracketToIcon(locationProperty.title),
                                              "item-title": "value",
                                              "item-value": "key"
                                            }, null, 8, ["onChange", "hint", "modelValue", "onUpdate:modelValue", "items", "label"]))
                                          : _createCommentVNode("", true),
                                        (locationProperty.dataType != 0 && locationProperty.choices !=null)
                                          ? (_openBlock(), _createBlock(_component_v_select, {
                                              key: 5,
                                              density: "compact",
                                              onChange: _ctx.changed,
                                              hint: locationProperty.description,
                                              modelValue: locationProperty.numberValue,
                                              "onUpdate:modelValue": ($event: any) => ((locationProperty.numberValue) = $event),
                                              variant: "outlined",
                                              items: locationProperty.choices,
                                              label: _ctx.removeMdiBracketToIcon(locationProperty.title),
                                              "item-title": "value",
                                              "item-value": "key"
                                            }, null, 8, ["onChange", "hint", "modelValue", "onUpdate:modelValue", "items", "label"]))
                                          : _createCommentVNode("", true)
                                      ])), [
                                        [_vShow, !section[1][0].sectionSecondary]
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]))
                              }), 128))
                            ], 64))
                          }), 256))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_divider),
                      _createVNode(_component_v_card_actions, null, {
                        default: _withCtx(() => [
                          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
                          _createVNode(_component_v_menu, {
                            color: "primary",
                            location: "bottom",
                            "close-on-content-click": false,
                            modelValue: _ctx.menu,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.menu) = $event))
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_btn, _mergeProps({ variant: "text" }, props, { color: "primary" }), {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("message.save")) + " ", 1),
                                  _createVNode(_component_v_icon, {
                                    end: "",
                                    color: "primary"
                                  }, {
                                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                      _createTextVNode("mdi-chevron-down", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 16)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        variant: "text",
                                        color: "primary",
                                        disabled: _ctx.location.changeType == 3 || _ctx.location.changeType == 1,
                                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.save(_ctx.scenario.parentScenarioId == null? _ctx.scenario.id : _ctx.scenario.parentScenarioId)))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(!_ctx.location.id ? _ctx.$t("message.saveAddToNewScenario") : _ctx.$t("message.saveEditInNewScenario")), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        variant: "text",
                                        color: "primary",
                                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.save(null))),
                                        disabled: _ctx.scenario.parentScenarioId == null
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(!_ctx.location.id ? _ctx.$t("message.saveAddToThisScenario") : _ctx.$t("message.saveEditInThisScenario")), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.model.scenarioHierarchy)
                                    ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            variant: "text",
                                            color: "primary",
                                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.save(_ctx.scenario.id))),
                                            disabled: _ctx.scenario.parentScenarioId == null || _ctx.location.changeType == 3 || _ctx.location.changeType == 1
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(!_ctx.location.id ? _ctx.$t("message.saveAddToNewNestedScenario") : _ctx.$t("message.saveEditInNewNestedScenario")), 1)
                                            ]),
                                            _: 1
                                          }, 8, ["disabled"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            variant: "text",
                            onClick: _ctx.close
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("message.cancel")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}